module.exports = __webpack_public_path__ + "static/media/settings.cbc29e21.svg";